import React, { Component } from 'react';

export default class ExpeditedRuleContent extends Component {
  render() {
    console.log('Expedited Rule content!!');
    return (
      <div>
        <div>
          <div>
            <p className="tabbedSectionComponent-contentTitle">Expedited</p>
            <p style={{ color: '#343434' }}>
              When an order is marked as expedited, a notification will be sent.
            </p>
          </div>
        </div>
      </div>
    );
  }
}
